export const entertainmentItems = [
  {
    id: 'e1',
    type: 'entertainment',
    title: '年度悬疑剧《迷雾之城》口碑爆棚',
    summary: '凭借缜密的剧情与电影级质感，《迷雾之城》开播即引发热议，观众追更热情高涨。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20moody%20city%20street%20at%20night%20with%20neon%20reflections%20in%20rain%2C%20editorial%20film%20poster%20style%20photography%2C%20clean%20dark%20neutral%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-01&orientation=landscape',
    category: 'entertainment',
    subCategory: '影视',
    genre: '悬疑剧',
    author: '91娱乐组',
    source: '影剧观察',
    publishTime: '2026-10-08 20:30',
    views: 186500,
    tags: ['悬疑剧', '迷雾之城', '热播'],
    content: [
      '年度悬疑剧《迷雾之城》近日开播，凭借缜密的剧情编排与电影级的画面质感，迅速登上多个平台热搜，成为观众热议的话题。',
      '该剧以一起看似普通的案件为起点，层层铺展人物关系与隐藏线索，随着剧情推进，真相逐渐浮出水面。紧凑的节奏与不断反转的设定，让不少观众直呼“一集入坑，根本停不下来”。',
      '制作团队在场景搭建与光影运用上颇为用心，冷峻的城市夜景与细腻的表演相得益彰，为观众营造出强烈的沉浸感。演员的表现也获得广泛认可，多个角色成为讨论焦点。',
      '业内人士表示，优质的悬疑题材作品需要在逻辑严密与情感共鸣之间取得平衡，《迷雾之城》在这方面做出了有益尝试，也为同类创作提供了参考。',
    ],
  },
  {
    id: 'e2',
    type: 'entertainment',
    title: '音乐节巡回演出燃爆夏夜',
    summary: '多支乐队轮番登台，舞台灯光与全场合唱交织，为乐迷带来难忘的现场音乐体验。',
    image:
      'https://readdy.ai/api/search-image?query=Energetic%20outdoor%20music%20festival%20crowd%20with%20colorful%20stage%20lights%20at%20night%2C%20editorial%20concert%20photography%2C%20clean%20dark%20neutral%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-02&orientation=landscape',
    category: 'entertainment',
    subCategory: '音乐',
    genre: '现场演出',
    author: '91娱乐组',
    source: '现场直击',
    publishTime: '2026-10-07 22:15',
    views: 132800,
    tags: ['音乐节', '乐队', '现场'],
    content: [
      '随着夜幕降临，音乐节巡回演出在欢呼声中拉开帷幕。多支乐队轮番登台，从抒情旋律到热烈摇滚，为现场乐迷带来一场酣畅淋漓的音乐盛宴。',
      '舞台灯光与音效配合默契，随着节奏不断变换，全场观众挥动荧光棒齐声合唱，气氛一次次被推向高潮。不少乐迷表示，现场的氛围是耳机里永远无法替代的体验。',
      '主办方介绍，本次巡演在多个城市设站，并根据各地观众喜好调整曲目编排，力求让每一场演出都有独特记忆点。',
      '音乐节的热度也带动了周边餐饮、住宿与文创消费，成为城市夜经济的一道亮丽风景。',
    ],
  },
  {
    id: 'e3',
    type: 'entertainment',
    title: '国产游戏新作全球同步上线',
    summary: '融合东方美学与创新玩法，国产游戏新作上线即获好评，海外玩家也纷纷点赞。',
    image:
      'https://readdy.ai/api/search-image?query=Fantasy%20game%20character%20silhouette%20in%20misty%20ancient%20oriental%20landscape%2C%20editorial%20game%20art%20style%20photography%2C%20clean%20neutral%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-03&orientation=landscape',
    category: 'entertainment',
    subCategory: '游戏',
    genre: '游戏',
    author: '91娱乐组',
    source: '游戏前线',
    publishTime: '2026-10-06 18:00',
    views: 174300,
    tags: ['国产游戏', '东方美学', '上线'],
    content: [
      '一款融合东方美学与创新玩法的国产游戏新作近日全球同步上线，凭借独特的艺术风格与扎实的游戏设计，迅速获得玩家好评，海外玩家也纷纷点赞。',
      '游戏以架空世界为背景，玩家在探索中逐步解锁剧情与能力。画面呈现出浓郁的东方韵味，音乐与场景设计相得益彰，营造出沉浸式的冒险体验。',
      '开发团队表示，作品创作历时数年，在玩法机制与叙事方式上进行了多次打磨，希望让更多玩家感受到东方文化的魅力。',
      '业内观察认为，越来越多国产游戏走向海外，不仅展现了制作水平的提升，也成为文化交流的新载体。',
    ],
  },
  {
    id: 'e4',
    type: 'entertainment',
    title: '综艺《生活实验室》温暖回归',
    summary: '全新一季聚焦日常生活中的小确幸，用轻松的视角记录普通人的有趣故事，治愈感十足。',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20warm%20living%20room%20with%20soft%20blanket%20and%20plants%20in%20golden%20afternoon%20light%2C%20editorial%20lifestyle%20photography%2C%20clean%20neutral%20background%2C%20soft%20natural%20light&width=800&height=600&seq=ent-04&orientation=landscape',
    category: 'entertainment',
    subCategory: '综艺',
    genre: '综艺',
    author: '91娱乐组',
    source: '综艺观察',
    publishTime: '2026-10-05 20:40',
    views: 118700,
    tags: ['综艺', '治愈', '生活实验室'],
    content: [
      '备受观众喜爱的综艺《生活实验室》温暖回归，全新一季继续聚焦日常生活中的小确幸，用轻松幽默的视角记录普通人的有趣故事。',
      '节目通过一系列生活化的实验与观察，展现人与人之间的温情互动。没有刻意的煽情，却能让人在会心一笑中感受到生活的美好。',
      '不少观众表示，节目的节奏舒缓、氛围治愈，适合在忙碌之后放松观看。嘉宾自然真实的表现也成为节目的一大看点。',
      '制作方透露，本季在选题上更加贴近大众生活，希望能引发更多共鸣，让观众在节目中找到自己的影子。',
    ],
  },
  {
    id: 'e5',
    type: 'entertainment',
    title: '纪录片《大地脉动》获国际大奖',
    summary: '历时数年拍摄的自然纪录片《大地脉动》凭借震撼画面与人文思考，斩获国际纪录片大奖。',
    image:
      'https://readdy.ai/api/search-image?query=Sweeping%20aerial%20view%20of%20vast%20mountains%20and%20green%20valley%20at%20sunrise%2C%20editorial%20nature%20documentary%20photography%2C%20clean%20neutral%20background%2C%20warm%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-05&orientation=landscape',
    category: 'entertainment',
    subCategory: '影视',
    genre: '纪录片',
    author: '91娱乐组',
    source: '影剧观察',
    publishTime: '2026-10-04 12:00',
    views: 98700,
    tags: ['纪录片', '自然', '获奖'],
    content: [
      '历时数年拍摄的自然纪录片《大地脉动》近日斩获国际纪录片大奖。影片以震撼的画面记录了山川、河流与野生动物的生存状态，也引发人们对人与自然关系的思考。',
      '摄制组足迹遍布多个自然保护区域，克服了高寒、湿热等艰苦条件，用镜头捕捉到许多珍贵瞬间。精美的影像与克制的叙事相结合，呈现出自然的力量与温柔。',
      '评委认为，作品不仅具有极高的观赏价值，更在环保理念的传递上做出了积极探索，是一部兼具艺术性与思想性的佳作。',
      '创作团队表示，希望通过这部作品唤起更多人对自然的敬畏与保护意识，让绿水青山永续长存。',
    ],
  },
  {
    id: 'e6',
    type: 'entertainment',
    title: '新生代乐队巡演门票秒罄',
    summary: '一支成立不久的新生代乐队凭实力圈粉，巡演门票开售即被抢空，成为乐坛黑马。',
    image:
      'https://readdy.ai/api/search-image?query=Young%20band%20performing%20on%20a%20small%20stage%20with%20warm%20spotlights%20and%20smoke%2C%20editorial%20music%20photography%2C%20clean%20dark%20neutral%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-06&orientation=landscape',
    category: 'entertainment',
    subCategory: '音乐',
    genre: '现场演出',
    author: '91娱乐组',
    source: '现场直击',
    publishTime: '2026-10-03 21:20',
    views: 145600,
    tags: ['乐队', '巡演', '黑马'],
    content: [
      '一支成立不久的新生代乐队凭借扎实的现场功底与鲜明的创作风格迅速走红，全国巡演门票开售即被抢空，成为乐坛备受关注的黑马。',
      '乐队的作品融合了多种音乐元素，旋律兼具力量与温度，歌词贴近年轻人的生活与情感，引起广泛共鸣。',
      '在演出现场，主唱与观众的互动频繁，气氛热烈。不少乐迷表示，被乐队的真诚与热情打动，愿意一路追随。',
      '业内人士认为，新生代音乐人的崛起为乐坛注入了活力，只要坚持创作并注重现场打磨，就有机会获得更多听众的认可。',
    ],
  },
  {
    id: 'e7',
    type: 'entertainment',
    title: '电竞联赛总决赛激战正酣',
    summary: '多支顶尖战队会师总决赛，战术博弈与精彩操作引爆全场，线上直播观看人数屡创新高。',
    image:
      'https://readdy.ai/api/search-image?query=Esports%20arena%20with%20large%20glowing%20screens%20and%20cheering%20crowd%20under%20blue%20stage%20light%2C%20editorial%20gaming%20photography%2C%20clean%20dark%20neutral%20background%2C%20dramatic%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-07&orientation=landscape',
    category: 'entertainment',
    subCategory: '游戏',
    genre: '电竞',
    author: '91娱乐组',
    source: '电竞前线',
    publishTime: '2026-10-02 19:50',
    views: 163400,
    tags: ['电竞', '总决赛', '直播'],
    content: [
      '电竞联赛总决赛近日拉开战幕，多支顶尖战队会师巅峰对决。选手们在赛场上展现出高超的操作与默契的配合，战术博弈精彩纷呈。',
      '现场座无虚席，观众的呐喊声此起彼伏。线上直播同样热度高涨，观看人数屡创新高，弹幕区讨论热烈，成为年轻人喜爱的观赛方式。',
      '赛事主办方在赛程安排与转播技术上不断优化，通过多机位与数据可视化呈现，让观众更直观地感受比赛的紧张与精彩。',
      '业内表示，电竞产业的规范化与专业化发展，为赛事运营、内容制作等环节带来了新的机遇，也吸引着越来越多年轻人的关注与参与。',
    ],
  },
  {
    id: 'e8',
    type: 'entertainment',
    title: '喜剧专场巡演笑点密集',
    summary: '喜剧演员用贴近生活的段子引发共鸣，全场笑声不断，成为年轻人解压放松的好去处。',
    image:
      'https://readdy.ai/api/search-image?query=Comedian%20performing%20under%20a%20warm%20spotlight%20on%20a%20simple%20stage%20with%20microphone%2C%20editorial%20comedy%20show%20photography%2C%20clean%20dark%20neutral%20background%2C%20dramatic%20lighting&width=800&height=600&seq=ent-08&orientation=landscape',
    category: 'entertainment',
    subCategory: '综艺',
    genre: '喜剧',
    author: '91娱乐组',
    source: '综艺观察',
    publishTime: '2026-10-01 20:10',
    views: 89700,
    tags: ['喜剧', '专场', '解压'],
    content: [
      '喜剧专场巡演近日在多个城市上演，喜剧演员用贴近生活的段子与机智的临场反应，让全场笑声不断，成为年轻人解压放松的热门选择。',
      '演出围绕工作、生活、情感等日常话题展开，笑点密集又不失温度，不少观众表示“笑到停不下来，压力也跟着释放了”。',
      '相比线上的观看，现场演出更具感染力，观众的即时反馈也让演员的表演更加松弛自然，形成良好的互动氛围。',
      '业内认为，喜剧市场的活跃反映出大众对轻松文化消费的需求正在增长，优质的原创内容将成为行业持续发展的关键。',
    ],
  },
  {
    id: 'e9',
    type: 'entertainment',
    title: '国风动画电影定档暑期',
    summary: '取材中国传统神话的国风动画电影宣布定档，精美国风画面与动人故事引发期待。',
    image:
      'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20painting%20style%20mountain%20and%20cloud%20landscape%2C%20editorial%20animation%20art%20photography%2C%20clean%20neutral%20background%2C%20soft%20lighting%2C%20high%20detail&width=800&height=600&seq=ent-09&orientation=landscape',
    category: 'entertainment',
    subCategory: '影视',
    genre: '动画电影',
    author: '91娱乐组',
    source: '影剧观察',
    publishTime: '2026-09-30 15:30',
    views: 105200,
    tags: ['国风', '动画电影', '暑期档'],
    content: [
      '一部取材中国传统神话的国风动画电影近日宣布定档暑期，精美的国风画面与动人的故事设定一经发布便引发广泛期待。',
      '影片在视觉呈现上大量借鉴传统绘画与建筑元素，山水、云纹与服饰细节考究，力求还原东方美学的独特韵味。',
      '在故事层面，影片以成长与亲情为核心，通过主角的冒险旅程传递勇气与温暖，兼顾观赏性与情感共鸣。',
      '业内人士表示，随着动画制作水平的提升，国产动画电影正不断拓宽题材与表达，期待更多优秀作品走向观众。',
    ],
  },
];